import axios from './axios';
import datefunctions from '../../helpers/datefunctions';

class Api {
    static getHomepageValues () {
        return axios.get('/weerstation1/homepagevalues');
    }

    static getHomepageTable () {
      return axios.get('/weerstation1/homepagetable');
    }

    static getValues (parameter, datumVan, datumTot) {
        const vdatum = datefunctions.datetoYYYYMMDD(datumVan);
        const tdatum = datefunctions.datetoYYYYMMDD(datumTot);
        return axios.get(`/weerstation1/values?parameter=${parameter}&datumVan=${vdatum}&datumTot=${tdatum}`);
    }

    static addDownload (payload) {
      return axios.post('/download', payload);
    }

}

export default Api;



// WEBPACK FOOTER //
// ./src/api/weerstation/weerstation.js